import { CacheElement } from "./Cache";

export class Caches {
  private static peopleCache = new CacheElement();
  private static organizationCache = new CacheElement();
  private static locationsCache = new CacheElement();
  private static projectsCache = new CacheElement();

  public static getProjectsCache(): CacheElement {
    return this.projectsCache;
  }

  public static getPeopleCache(): CacheElement {
    return this.peopleCache;
  }

  public static getOrganizationCache(): CacheElement {
    return this.organizationCache;
  }

  public static getLocationsCache(): CacheElement {
    return this.locationsCache;
  }
}
